import axios from 'axios';
import { dispatch } from 'nike-re-framejs';
import Immutable, { List } from 'immutable';
import { pathSubscription } from 'nike-re-framejs';

export const fillDocuments = documents => db => db.setIn(['upload', 'slots'], Immutable.fromJS(documents));

export const fetchContactUsSlots = () => {
    axios.get('/api/dms/slots/contact-us').then(documents => dispatch(fillDocuments(documents)));
};

export const contactUsSlots$ = pathSubscription(['upload', 'slots'], List());
